import { BaseUserSchema, UserRes, UserSchema } from '@models/User';
import { loadConfig } from '@api/api';
import axios, { AxiosResponse } from 'axios';

const getUserApi = async () => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/user`;
};

export const getUser = async ({
  accessToken,
  params = {},
}: {
  accessToken: string;
  params?: Partial<{
    page: number;
    limit: number;
    filters: Record<string, any>;
    sort: Record<string, any>;
  }>;
}) => {
  const User_URL = await getUserApi();
  const defaultParams = {
    page: 1,
    limit: 100,
    filters: {},
    sort: [],
  };
  const mergedParams = { ...defaultParams, ...params };
  const response: AxiosResponse<UserRes> = await axios
    .get(`${User_URL}`, {
      params: mergedParams,
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};

export const postUser = async ({
  accessToken,
  params,
}: {
  accessToken: string;
  params: BaseUserSchema;
}) => {
  const User_URL = await getUserApi();
  const response: AxiosResponse = await axios
    .post(User_URL, params, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};

export const patchUser = async ({
  accessToken,
  params,
  id,
}: {
  accessToken: string;
  params: Partial<BaseUserSchema>;
  id: string;
}) => {
  const User_URL = await getUserApi();
  const response: AxiosResponse = await axios
    .patch(`${User_URL}/${id}`, params, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};

export const deleteUser = async ({
  accessToken,
  id,
}: {
  accessToken: string;
  id: string;
}) => {
  const User_URL = await getUserApi();
  const response: AxiosResponse = await axios
    .delete(`${User_URL}/${id}`, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};
